import {
    GET_DIVISIONAL_APPROVER_REQUISITION_TYPE,
    SET_DIVISIONAL_APPROVER_REQUISITION_TYPE
} from "./DivisionalApproverRequisitionTypeType"

const getDivisionalApproverRequisitionType = () => ({
    type: GET_DIVISIONAL_APPROVER_REQUISITION_TYPE
});

const setDivisionalApproverRequisitionType = (divisionalApproverRequisitionTypeList: any) => ({
    type: SET_DIVISIONAL_APPROVER_REQUISITION_TYPE,
    divisionalApproverRequisitionTypeList
});

export {
    getDivisionalApproverRequisitionType,
    setDivisionalApproverRequisitionType
}
